import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { AppHelper } from "../appHelper";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { TargetEntityType } from "./reportMetaData";
import { Grid } from "../core/components/grid";
import { Config } from "../core/config/config";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { FAIcon } from "../core/components/faIcon";
import { General } from "../../siteManagement/general";
import { DropDownList } from "../core/components/dropDownList";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { Dialog, DialogProps } from "../core/components/dialog";
import { Sheet } from "../../siteManagement/sheet";
import { RightDrawerContainer } from "../core/components/rightDrawerContainer";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export default class PrintJobs extends React.Component<PrintJobsProps, any>{
    common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    getGrid = (): JSX.Element => {
        return (
            <>
                {<PrintJobsGrids historyRange={this.props.historyRange} />}
            </>
        );
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} title={"Aufträge"} />;
    }
}

export interface PrintJobsProps extends AppBaseProps {
    historyRange: number;
    metadata: any;
}

class PrintJobsGrids extends React.Component<PrintJobsGridProps, PrintJobsState> {
    private completedprintJobGridOptions: kendo.ui.GridOptions;
    private pendingPrintJobsGridOptions: kendo.ui.GridOptions;
    private intervalTokken: number;
    private translations: StringKeyDictionary<string>;
    private rSplitterRef: RSplitter;
    private rightDrawerContainer: any;

    constructor(props: PrintJobsGridProps) {
        super(props);
        this.intervalTokken = null;
        this.translations = null;
        this.state = {
            printJobs: [],
            previewOpen: false,
            selectedJob: null,
            filter: {
                historyRange: props.historyRange,
                name: "",
                targetEntityType: null
            }
        }
        this.getPrintJobs();
        this.initApp();
    }

    private initApp = () => {
        Helper.getTranslations([
            "WebSMS.ReportMetadata.TargetEntityType",
            "WebSMS.QRReports.FileName",
            "WebSMS.QRReports.SuccessfullyCreated",
            "Server.Download",
            "WebSMS.ReportMetadata.SubmittedAt",
            "WebSMS.ReportMetadata.FinishedAt",
            "Standard.Name",
            "WebSMS.ReportMetadata.TargetEntityType",
            "WebSMS.ReportMetadata.PeriodInH",
            "Standard.Preview",
            "WebSMS.ReportMetadata.CompletedJobs",
            "WebSMS.ReportMetadata.NoPdf"
        ]).then((result) => {
            this.translations = result.Data;
            this.completedprintJobGridOptions = {
                sortable: true,
                pageable: false,
                groupable: false,
                filterable: false,
                selectable: true,
                resizable: true,
                scrollable: true,
                columns: [
                    //{
                    //    field: "JobId",
                    //    title: "JobId"
                    //},
                    {
                        field: "FileName",
                        title: this.translations["WebSMS.QRReports.FileName"]
                    },
                    {
                        field: "TargetTypeName",
                        title: this.translations["WebSMS.ReportMetadata.TargetEntityType"]
                    },
                    {
                        field: "IsSuccess",
                        title: this.translations["WebSMS.QRReports.SuccessfullyCreated"],
                        template: "# if(data.IsSuccess) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#",
                    },
                    {
                        field: "SubmittedAt",
                        title: this.translations["WebSMS.ReportMetadata.SubmittedAt"],
                        template: "#= kendo.toString(kendo.parseDate(SubmittedAt), 'd')  + ' ' + kendo.toString(kendo.parseDate(SubmittedAt), 'hh:mm:ss')#"
                    },
                    {
                        field: "FinishedAt",
                        title: this.translations["WebSMS.ReportMetadata.FinishedAt"],
                        template: "#let displayDate = ''; if(data.IsSuccess){displayDate = kendo.toString(kendo.parseDate(data.FinishedAt), 'd') + ' ' + kendo.toString(kendo.parseDate(data.FinishedAt), 'HH:mm:ss');}##= displayDate#"
                    }
                ]
            }
            this.pendingPrintJobsGridOptions = {
                sortable: true,
                pageable: false,
                groupable: false,
                filterable: false,
                selectable: true,
                resizable: true,
                scrollable: true,
                columns: [
                    //{
                    //    field: "JobId",
                    //    title: "JobId"
                    //},
                    {
                        field: "FileName",
                        title: this.translations["WebSMS.QRReports.FileName"]
                    },
                    {
                        field: "TargetTypeName",
                        title: this.translations["WebSMS.ReportMetadata.TargetEntityType"]
                    },
                    {
                        field: "SubmittedAt",
                        title: this.translations["WebSMS.ReportMetadata.SubmittedAt"],
                        template: "#= kendo.toString(kendo.parseDate(SubmittedAt), 'd')  + ' ' + kendo.toString(kendo.parseDate(SubmittedAt), 'hh:mm:ss')#"
                    }
                ]
            }
            this.setState({});
        });
    }

    private getPrintJobs = (busyIndicator: boolean = true) => {
        let url = "AtlasQrReportPrint/GetLastPrintJobs"
        if (Helper.hasValue(this.state.filter.historyRange)) {
            url += "?historyRange=" + this.state.filter.historyRange;
        }
        const callBack = (result: JsonResultClass<PrintJob[]>) => {
            if (result.Code === 0) {
                this.setState({ printJobs: result.Data })
            }
        }

        if (busyIndicator) {
            HTTPService.get<JsonResultClass<PrintJob[]>>(url).then(callBack);
        } else {
            createHtppServiceInstance().noBusyIndicator().get<JsonResultClass<PrintJob[]>>(url).then(callBack);
        }
    }

    private setInterval = () => {
        this.intervalTokken = window.setInterval(() => {
            this.getPrintJobs(false);
        }, 30000)
    }

    private createPrintJobsGrid = () => {

        const containsName = (value: string) => {
            return !Helper.isNullOrEmpty(value) && value.toLowerCase().includes(this.state.filter.name.toLowerCase())
        }

        const getDataSource = (): PrintJob[] => {
            let result = this.state.printJobs.filter(f => f.IsCompleted);
            if (Helper.hasValue(this.state.filter.targetEntityType)) {
                result = result.filter(f => f.TargetType === this.state.filter.targetEntityType);
            }
            if (!Helper.isNullOrEmpty(this.state.filter.name)) {
                result = result.filter(f => containsName(f.FileName));
            }
            result = result.sort((a: PrintJob, b: PrintJob) => {
                let timeA = Helper.dates.toDate(a.FinishedAt).getTime();
                let timeB = Helper.dates.toDate(b.FinishedAt).getTime();
                if (timeA < timeB) {
                    return 1;
                }
                if (timeA > timeB) {
                    return -1;
                }
                timeA = Helper.dates.toDate(a.SubmittedAt).getTime();
                timeB = Helper.dates.toDate(b.SubmittedAt).getTime();
                if (timeA < timeB) {
                    return 1;
                }
                if (timeA > timeB) {
                    return -1;
                }
                return 0;
            });
            return result;
        }


        const customButtons: GridCustomToolBarButton[] = [
            { autoEnabledOnRecordSelected: true, caption: this.translations["Server.Download"], enabled: Helper.hasValue(this.state.selectedJob) && this.state.selectedJob.IsSuccess, iconClass: "fas fa-download", id: "download" },
            { autoEnabledOnRecordSelected: true, caption: this.translations["Standard.Preview"], enabled: Helper.hasValue(this.state.selectedJob) && this.state.selectedJob.IsSuccess, iconClass: "fas fa-eye", id: "preview" },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("WebSMS.QRReports.ShowErrors"), enabled: Helper.hasValue(this.state.selectedJob) && !this.state.selectedJob.IsSuccess, iconClass: "fa-regular fa-triangle-exclamation", id: "showErrors" },
        ];
        return (
            <div>
                <Grid
                    customButtons={customButtons}
                    onClickCustomButton={this.onCustomButtonClick}
                    data={getDataSource()}
                    options={this.completedprintJobGridOptions}
                    id="printJobs"
                    onSelectionChanged={this.onSelectionChanged}
                />
            </div>
        );
    }

    private createPendingGrid = () => {
        const dataSource = this.state.printJobs.filter(f => !f.IsCompleted);
        const header: JSX.Element = (
            <>
                <div style={{
                    margin: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }} key={kendo.guid()}>
                    <label style={{ fontSize: "28px" }}>{this.translations["WebSMS.ReportMetadata.PendingJobs"]}</label>
                </div>
            </>
        );

        if (dataSource.length > 0) {
            return (
                <>
                    {header}
                    <div className="flex-container">
                        <Grid
                            data={dataSource}
                            options={this.pendingPrintJobsGridOptions}
                            id="pendingPrintJobs"
                        />
                    </div>
                </>
            );
        } else {
            return (
                <div style={{ display: "grid" }}>
                    <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                        <span className="fa-stack fa-5x" style={{ opacity: 0.1 }}>
                            <i className="fal fa-file fa-stack-1x"></i>
                            <i className="fal fa-ban fa-stack-2x"></i>
                        </span>
                    </div>
                    <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "50px" }}>
                        <label style={{ fontSize: "20px" }}>
                            {this.translations["WebSMS.ReportMetadata.NoPdf"]}
                        </label>
                    </div>
                </div>
            );
        }
    }

    private createFilter = () => {
        let props: SearchElementsProps = {
            onClick: (filter: Filter) => { this.setState({ filter: filter }, this.getPrintJobs) },
            translations: this.translations,
            historyRange: this.state.filter.historyRange,
            name: this.state.filter.name,
            targetEntityType: this.state.filter.targetEntityType
        }
        return (<><SearchElements {...props} /></>);
    }

    private onSelectionChanged = (dataItem: PrintJob) => {
        let previewOpen = this.state.previewOpen;
        if (!Helper.hasValue(dataItem) || !dataItem.IsSuccess) {
            previewOpen = false;
        }
        this.setState({ selectedJob: dataItem, previewOpen: previewOpen })
    }

    private onCustomButtonClick = (id: string, dataItem: PrintJob) => {
        switch (id) {
            case "download":
                this.downloadFile(dataItem);
                break;
            case "preview":
                this.setState({ previewOpen: !this.state.previewOpen })
                break;
            case "showErrors":
                this.showErrors(dataItem.JobId);
                break;
        }
    }

    private showErrors = async (jobId: number) => {
        const url = `AtlasQrReportPrint/GetErrorMessages?jobId=${jobId}`;
        const result = await HTTPService.get<JsonResultClass<string[]>>(url);

        const targetElement = $("<div>");
        const dialogProps: DialogProps = {
            title: Helper.getTranslation("Standard.Fehler"),
            width: 450,
            actions: [
                {
                    label: Helper.getTranslation("WebSMS.Report.Report.Status.Ok"),
                    action: () => {

                    },
                    primary: true
                }
            ],
            afterClose: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
        };
        $("body").append(targetElement);
        ReactDOM.render(
            <Dialog {...dialogProps} open={true}>
                <table>
                    <tbody>
                        <tr>
                            <td style={{ paddingLeft: "25px" }}>
                                <ul>
                                    {result.Data.map((error: string) => {
                                        return (
                                            <React.Fragment key={kendo.guid()}>
                                                <li style={{ listStyle: "disc" }}>
                                                    {error}
                                                </li>
                                            </React.Fragment>
                                        );
                                    })}
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Dialog >, targetElement[0]
        );

    }

    private downloadFile = (dataItem: PrintJob) => {
        Helper.openInNewBrowserTab(`${Config.baseUrl}AtlasQrReportPrint/DownloadReport?jobId=${dataItem.JobId}`);
    }

    private removeStupidScrollbar = () => {
        let nodes = this.rSplitterRef.getWrapperRef().childNodes;
        if (nodes.length > 2) {
            let stupidDivElementWithStupidScrollbar = nodes[2] as HTMLElement;
            stupidDivElementWithStupidScrollbar.style.overflow = "hidden";
        }
    }
    private renderRightDrawerComponent = () => {
        let baseUrl = "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/administration/administrieren-der-anwendung/quickreports/druckauftraege-ueberpruefen";
        if (this.rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };
            let helpUrl = {
                url: baseUrl
            };
            return <RightDrawerContainer
                moduleName={"app/core/components/iframe"}
                appName={undefined}
                visible={true}
                width={400}
                customProps={helpUrl}
                entity={entity}
                renderAlways={true}
                multipleComponents={undefined}
            />
        }

        return null;
    }
    componentDidMount() {
        this.setInterval();
        this.removeStupidScrollbar();
    }

    componentWillUnmount() {
        clearInterval(this.intervalTokken);
    }

    render() {
        const headerLabelStyle: React.CSSProperties = {
            margin: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
        return (
            <>
                {this.renderRightDrawerComponent()}
                <RSplitter direction={RSplitterDirection.Vertical} initialPercentage={23} ref={(ref) => { this.rSplitterRef = ref; }}>
                    <>
                        {Helper.hasValue(this.translations) ? this.createPendingGrid() : null}
                    </>
                    <FullHeightContainer>
                        <div style={headerLabelStyle}>
                            <label style={{ fontSize: "28px" }}>{Helper.hasValue(this.translations) ? this.translations["WebSMS.ReportMetadata.CompletedJobs"] : "Completed jobs"}</label>
                        </div>
                        <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={65}>
                            {Helper.hasValue(this.translations) ? this.createPrintJobsGrid() : null}
                            {this.state.previewOpen ? <>< PdfPreview jobId={this.state.selectedJob.JobId} /></> : null}
                        </RSplitter>
                    </FullHeightContainer>
                </RSplitter>
                {Helper.hasValue(this.translations) ? this.createFilter() : null}
            </>
        );
    }
}

interface PrintJobsGridProps {
    historyRange: number;
}

interface PrintJobsState {
    printJobs: PrintJob[];
    selectedJob: PrintJob;
    previewOpen: boolean;
    filter: Filter
}

interface PrintJob {
    EntityId: string;
    FileName: string;
    FilePath: string;
    IsCompleted: boolean;
    IsSuccess: boolean;
    JobId: number;
    Status: number;
    SubmittedAt: string | Date;
    TargetType: TargetEntityType;
    TargetTypeName: string;
    FinishedAt: string | Date;
}

class SearchElements extends React.Component<SearchElementsProps, SearchElementsState>{
    private leftDrawerRef: JQuery<HTMLElement>;
    private factory = ComponentHelper.createFactory();
    private sheet: Sheet;

    constructor(props: SearchElementsProps) {
        super(props);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.leftDrawerRef = this.sheet.elements.getLeftDrawerElementRef();
        this.state = {
            historyRange: props.historyRange,
            name: props.name,
            targetEntityType: props.targetEntityType
        }
        this.setEvents();
    }

    private setEvents = () => {
        $(document).keydown(this.onKeyDown);

    }

    private onKeyDown = (e: JQuery.KeyDownEvent) => {
        if (General.Sheet.Manager.getTopMostSheet().id() === this.sheet.id() && !Helper.isDialogOpen()) {
            const enter = 13;
            const keyCode = e.keyCode;
            switch (keyCode) {
                case enter:
                    this.onClick();
                    break;
            }
        }
    }

    private onClick = () => {
        this.props.onClick({ historyRange: this.state.historyRange, name: this.state.name, targetEntityType: this.state.targetEntityType })
    }

    private createSearchElement = (element: JSX.Element, label: string) => {
        return (
            <div style={{ margin: "5px 0" }}>
                <label>{label}</label>
                {element}
            </div>
        );
    }

    private createEntityTypeDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.state.targetEntityType;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.dataSourceUrl = "ReportMetaData/GetEntityTypes";
        props.onChange = (field, value) => {
            if (typeof value === "string" && Helper.isNullOrEmpty(value)) {
                value = null;
            }
            this.setState({ targetEntityType: value });
        }
        return this.createSearchElement(<><DropDownList {...props} /></>, this.props.translations["WebSMS.ReportMetadata.TargetEntityType"]);
    }
    private createNameTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.name, "");
        props.field.triggerOnChange = true;
        props.onChange = (field, value: string) => {
            this.setState({ name: value });
        }
        return this.createSearchElement(<><TextBox {...props} /></>, this.props.translations["Standard.Name"]);
    }
    private createHistoryRangeNumericBox = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.historyRange;
        props.field.min = 0;
        props.onChange = (field, value) => {
            this.setState({ historyRange: value });
        }
        return this.createSearchElement(<><IsNumericTextBox {...props} /></>, this.props.translations["WebSMS.ReportMetadata.PeriodInH"]);
    }

    render() {
        let filter: JSX.Element = (
            <div className="drawer__content">
                <FullHeightContainer style={{ padding: "10px" }} >
                    <button className="k-button" onClick={this.onClick} style={{ backgroundColor: "var( --primary-color)", color: "white", height: "36px", border: "1px solid var(--secondary-color)", borderRadius: "var(--border-radius)", fontSize: "16px", marginBottom: "5px" }}>
                        {Helper.getTranslation("Standard.Suche")}
                    </button>
                    {this.createHistoryRangeNumericBox()}
                    {this.createNameTextBox()}
                    {this.createEntityTypeDropDown()}
                </FullHeightContainer>
            </div>
        );
        return ReactDOM.createPortal(filter, this.leftDrawerRef[0]);
    }
}

interface SearchElementsState extends Filter { }
interface SearchElementsProps {
    historyRange?: number;
    name?: string;
    targetEntityType?: TargetEntityType;
    translations: StringKeyDictionary<string>;
    onClick: (filter: Filter) => void
}

interface Filter {
    historyRange: number;
    name: string;
    targetEntityType: TargetEntityType;
}


class PdfPreview extends React.Component<{ jobId: number }, any>{

    render() {
        const encoded = encodeURIComponent(`${Config.baseUrl}AtlasQrReportPrint/DownloadReport?jobId=${this.props.jobId}`);
        return (
            <iframe style={{ flex: 1, height: "100%", width: "100%", display: "block" }} src={`${Config.baseUrl}pdfviewer/web/viewer.html?file=${encoded}`} />
        )
    }
}